// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q7-2";
export var chatLink = "_q7-0";
export var chatText = "_q7-1";